import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Events, IonicPage, NavController, NavParams, Tab, Tabs } from 'ionic-angular';
import { HomeBloc } from '../../../bloc/feature/home/home.bloc';
import { AppPreferences } from '../../../shared/local/app-preferences.local';

/**
 * Generated class for the TabsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-tabs',
  templateUrl: 'tabs.html',
})
export class TabsPage {

  public tabIcons: string[] = [
    'assets/icon/home-tabs/feeds-icon.svg',
    'assets/icon/home-tabs/features-icon.svg',
    'assets/icon/home-tabs/home-icon.svg',
    'assets/icon/home-tabs/dashboard-icon.svg',
    'assets/icon/home-tabs/request-icon.svg',
  ]

  public tabList = [];
  public selectedIndex = null;
  @ViewChild('myTabs') tabRef: Tabs;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    public homeBloc: HomeBloc,
    public appPreferences: AppPreferences,
    public translate: TranslateService,
  ) {
    this.createTabs();
  }

  ngAfterViewInit() {
    setTimeout(() => this.createTabsIcons(), 500);
  }

  createTabs() {
    const auth = this.appPreferences.dataAuth;
    if (auth && auth.isSF6 && auth.sfversion && Math.floor(Number(auth.sfversion)) >= 7) {
      this.tabList = [
        {
          title: 'Feeds', //this.translate.instant('Feeds'),
          root: 'FeedsPage',
          tabBadge: null,
          tabBadgeStyle: null,
          class: ''
        },
        {
          title: 'Home', //this.translate.instant('Home'),
          root: 'HomePage',
          tabBadge: null,
          tabBadgeStyle: null,
          class: ''
        },
        {
          title: 'Company', //this.translate.instant('Company'),
          root: 'DashboardPage',
          tabBadge: null,
          tabBadgeStyle: null,
          class: ''
        },
        {
          title: 'Inbox', //this.translate.instant('Request'),
          root: 'WebviewPage',
          tabBadge: this.homeBloc.requestBadge.approval,
          tabBadgeStyle: 'danger',
          class: 'custom-badge'
        }
      ]
      this.selectedIndex = 1;
    } else {
      this.tabList = [
        {
          title: 'Feeds', //this.translate.instant('Feeds'),
          root: 'FeedsPage',
          tabBadge: null,
          tabBadgeStyle: null,
          class: ''
        },
        {
          title: this.translate.instant('Features'),
          root: 'FeaturesPage',
          tabBadge: null,
          tabBadgeStyle: null,
          class: ''
        }, 
        {
          title: 'Home', //this.translate.instant('Home'),
          root: 'HomePage',
          tabBadge: null,
          tabBadgeStyle: null,
          class: ''
        },
        {
          title: 'Company', //this.translate.instant('Company'),
          root: 'DashboardPage',
          tabBadge: null,
          tabBadgeStyle: null,
          class: ''
        },
        {
          title: 'Request', //this.translate.instant('Request'),
          root: 'RequestPage',
          tabBadge: this.homeBloc.requestBadge.approval,
          tabBadgeStyle: 'danger',
          class: 'custom-badge'
        }
      ]
      this.selectedIndex = 2;
    }
  }

  openPage(tab) {
    console.log(tab)
  }

  createTabsIcons(): void {
    let tabbar = document.getElementsByClassName('tabbar')[0];
    tabbar.setAttribute("id", "tabs-intro");
    let tabs = tabbar.getElementsByTagName('a');
    for (let i = 0; i < tabs.length; i++) {
      let tabs = tabbar.getElementsByTagName('a');
      let img = this.createIconImage(this.tabIcons[i]);
      tabs[i].insertBefore(img, tabs[i].childNodes[1]);

      //if tabs or img not exist, repeat
      if (tabs[0].getElementsByTagName('img').length < 1) {
        let that = this;
        setTimeout(function () {
          that.retryInsertIcon(img, tabs[i], 2);
        }, 2000)
      }
    }
  }

  retryInsertIcon(icon: any, tab: any, attempt: number) {
    console.log("retryInsertIcon()", "attempt:" + attempt);
    if (tab.getElementsByTagName('img').length < 1) {

      // retry insert
      tab.insertBefore(icon, tab.childNodes[1]);

      if (tab.getElementsByTagName('img').length < 1 && attempt > 0) {
        let that = this;
        setTimeout(function () {
          that.retryInsertIcon(icon, tab, --attempt);
        }, 2000)
      }
    }
  }

  createIconImage(iconUri: string) {
    let img = document.createElement("img");
    img.setAttribute("class", "tab-icon-custom tab-button-icon icon icon-md ion-md-bookmarks");
    img.setAttribute("style", "width:24px; height: 24px; display: block;");
    img.setAttribute("src", iconUri);
    return img;
  }

  ionViewDidEnter() {
    try {
      let tab: Tab = this.tabRef.getSelected();
      if (tab.root === 'RequestPage') {
        this.events.publish('reload-request');
      }
    } catch (error) { }
  }

}



// WEBPACK FOOTER //
// ./src/pages/home-tabs/tabs/tabs.ts